import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, signal, input } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { interval } from 'rxjs'
import { LiveEventTimeService } from '@/shared/components/other/event-table/event-info/live-event-time/live-event-time.service'
import { SearchMatchItem } from '@/features/search/search.model'
import { LiveEventBadgeComponent } from '@/shared/components/other/event-table/event-info/live-event-badge/live-event-badge.component'

const LIVE_TICK_MS = 4000

@Component({
	selector: 'match-panel-card',
	templateUrl: './match-panel-card.component.html',
	styleUrls: ['./panel-card.css', './match-panel-card.component.css'],
	imports: [LiveEventBadgeComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatchPanelCardComponent implements OnInit {
	readonly item = input.required<SearchMatchItem>()

	protected readonly timeLabel = signal('')

	constructor(
		private liveEventTimeService: LiveEventTimeService,
		private destroyRef: DestroyRef
	) {}

	ngOnInit(): void {
		const item = this.item()
		if (!item.isLive) {
			this.timeLabel.set(item.startLabel)
			return
		}

		this.updateLiveTime()
		interval(LIVE_TICK_MS)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => this.updateLiveTime())
	}

	private updateLiveTime(): void {
		const clock = this.item().data.eventClock
		this.timeLabel.set(clock?.show ? `${this.item().data.statusName} ${this.liveEventTimeService.calculate(clock).min}’` : '')
	}
}
